import { Directive, ElementRef, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class AutosizeDirective {
    /**
     * @param {?} elem
     */
    constructor(elem) {
        this.elem = elem;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.resize();
    }
    /**
     * @return {?}
     */
    resize() {
        const /** @type {?} */ textarea = /** @type {?} */ (this.elem.nativeElement);
        // Reset textarea height to auto that correctly calculate the new height
        textarea.style.height = 'auto';
        // Set new height
        textarea.style.height = `${textarea.scrollHeight}px`;
    }
}
AutosizeDirective.ɵfac = function AutosizeDirective_Factory(t) { return new (t || AutosizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AutosizeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AutosizeDirective, selectors: [["textarea", "autosize", ""]], hostAttrs: ["rows", "1", 2, "overflow", "hidden"], hostBindings: function AutosizeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function AutosizeDirective_input_HostBindingHandler() { return ctx.resize(); });
    } } });
/** @nocollapse */
AutosizeDirective.ctorParameters = () => [
    { type: ElementRef, },
];
AutosizeDirective.propDecorators = {
    "resize": [{ type: HostListener, args: ['input',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutosizeDirective, [{
        type: Directive,
        args: [{
                selector: 'textarea[autosize]',
                host: {
                    'rows': '1',
                    'style': 'overflow: hidden'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { 
    /**
     * @return {?}
     */
    resize: [{
            type: HostListener,
            args: ['input']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TextareaAutosizeModule {
}
TextareaAutosizeModule.ɵfac = function TextareaAutosizeModule_Factory(t) { return new (t || TextareaAutosizeModule)(); };
TextareaAutosizeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TextareaAutosizeModule });
TextareaAutosizeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
/** @nocollapse */
TextareaAutosizeModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaAutosizeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [AutosizeDirective],
                exports: [AutosizeDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextareaAutosizeModule, { declarations: function () { return [AutosizeDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AutosizeDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { TextareaAutosizeModule, AutosizeDirective as ɵa };

